import { handleActions, createAction } from 'redux-actions';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';

// Actions
export const actions = mapActions([
    'FETCH_TOD_HEATMAP',
    'FETCH_TOD_HEATMAP_SUCCESS',
    'FETCH_SITES_SUMMARY_DATA',
    'FETCH_SITES_SUMMARY_SUCCESS',
    'RESET_TO_INITIAL_STATE'
], 'TTD');

// Action Creators
export const fetchTimeOfDayHeatMap = createAction(actions.FETCH_TOD_HEATMAP, params => params);
export const timeOfDayHeatMapFetched = createAction(actions.FETCH_TOD_HEATMAP_SUCCESS, data => data);
export const fetchSitesSummaryData = createAction(
    actions.FETCH_SITES_SUMMARY_DATA,
    params => params
);
export const sitesSummaryDataFetched = createAction(
    actions.FETCH_SITES_SUMMARY_SUCCESS,
    data => data
);
export const resetTTDInitialState = createAction(actions.RESET_TO_INITIAL_STATE);

// Reducers
const initialState = {
    timeOfDay: {
        data: null,
        categories: {},
        hasData: null
    },
    sitesSummary: {
        data: null,
        categories: {},
        hasData: null
    }
};

export default handleActions({

    [actions.FETCH_TOD_HEATMAP_SUCCESS]: (state, action) => {
        const { hasData } = action.payload.params;

        if (hasData) {
            const updatedData = { timeOfDay: {
                data: { $set: action.payload.data },
                categories: { $set: action.payload.categories },
                hasData: { $set: hasData }
            } };
            return update(state, updatedData);
        }

        const updatedData = { timeOfDay: { hasData: { $set: hasData } } };
        return update(state, updatedData);
    },
    [actions.FETCH_SITES_SUMMARY_SUCCESS]: (state, action) => {
        const { hasData } = action.payload.params;
        let updatedData;

        if (hasData) {
            updatedData = { sitesSummary: {
                data: { $set: action.payload.data },
                categories: { $set: action.payload.categories },
                hasData: { $set: hasData }
            } };
        } else {
            updatedData = {
                sitesSummary: { hasData: { $set: hasData } }
            };
        }

        return update(state, updatedData);
    },
    [actions.RESET_TO_INITIAL_STATE]: state => update(state, { $set: initialState })

}, initialState);



// WEBPACK FOOTER //
// ./src/services/ttd/duck.js